import type { SVGProps } from "react";
const SvgFrownyFace = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={115.997}
    height={116}
    fill="none"
    fillRule="evenodd"
    stroke="#000"
    strokeLinejoin="bevel"
    strokeMiterlimit={10}
    strokeWidth={0.501}
    fontFamily="Times New Roman"
    fontSize={16}
    overflow="visible"
    style={{
      fontVariantLigatures: "none",
    }}
    viewBox="77.25 -737.25 86.998 87"
    {...props}
  >
    <g
      stroke="none"
      strokeLinejoin="miter"
      strokeWidth={0.75}
      transform="scale(1 -1)"
    >
      <circle
        r={43.505}
        fill="#b84927"
        transform="rotate(135 -83.306 371.883)"
      />
      <g fill="#262626">
        <path d="M98.346 671.347c-12.098 12.1-12.098 31.74 0 43.838s31.739 12.099 43.838 0 12.099-31.738 0-43.838c-12.099-12.098-31.739-12.098-43.838 0m40.318 3.52c10.189 10.19 10.189 26.727 0 36.916s-26.726 10.188-36.915 0-10.189-26.726 0-36.916c10.189-10.188 26.726-10.188 36.915 0" />
        <path
          fillRule="nonzero"
          d="M106.285 693.18c-.168-1.029.531-2.017 1.484-2.626.995-.638 2.414-.987 4.087-.742 1.738.257 2.974 1.223 3.701 2.324.706 1.066.993 2.362.673 3.325a.7.7 0 0 1-1.143.282c-2.506-2.379-5.335-2.963-7.873-2.02a.69.69 0 0 1-.592-.052.7.7 0 0 1-.337-.491M134.294 693.18c.165-1.029-.534-2.017-1.486-2.626-.995-.638-2.414-.987-4.088-.742-1.739.257-2.974 1.223-3.702 2.324-.704 1.066-.993 2.362-.669 3.325a.695.695 0 0 0 1.14.282c2.506-2.379 5.335-2.963 7.873-2.02a.7.7 0 0 0 .593-.052.7.7 0 0 0 .339-.491M115.012 678.323c2.793 3.718 8.374 3.718 11.164 0a1.74 1.74 0 0 1 2.441-.348c.77.575.925 1.668.35 2.438-4.186 5.581-12.557 5.581-16.743 0a1.74 1.74 0 0 1 .348-2.438 1.74 1.74 0 0 1 2.44.348M139.587 682.038a3.551 3.551 0 1 0-7.103 0c0 3.108 3.552 6.216 3.552 6.216s3.551-3.108 3.551-6.216"
        />
      </g>
      <g fill="#f7e5c5">
        <path d="M99.313 672.314c-12.099 12.099-12.099 31.739 0 43.838s31.739 12.099 43.838 0 12.099-31.739 0-43.838-31.739-12.099-43.838 0m40.318 3.52c10.189 10.189 10.189 26.727 0 36.915-10.189 10.189-26.727 10.189-36.915 0-10.189-10.188-10.189-26.726 0-36.915s26.726-10.189 36.915 0" />
        <path
          fillRule="nonzero"
          d="M107.251 694.146c-.167-1.029.532-2.016 1.484-2.626.995-.638 2.415-.986 4.087-.741 1.739.257 2.975 1.223 3.702 2.324.706 1.065.993 2.362.672 3.325a.7.7 0 0 1-1.142.282c-2.506-2.379-5.335-2.963-7.873-2.02a.7.7 0 0 1-.593-.053.7.7 0 0 1-.337-.491M135.26 694.146c.166-1.029-.533-2.016-1.486-2.626-.995-.638-2.414-.986-4.087-.741-1.739.257-2.974 1.223-3.702 2.324-.704 1.065-.993 2.362-.669 3.325.074.225.26.395.493.453a.7.7 0 0 0 .647-.171c2.506-2.379 5.335-2.963 7.873-2.02a.7.7 0 0 0 .593-.053.69.69 0 0 0 .338-.491M115.979 679.289c2.793 3.718 8.374 3.718 11.163 0a1.744 1.744 0 0 1 2.792 2.091c-4.186 5.581-12.557 5.581-16.744 0a1.74 1.74 0 0 1 .349-2.439 1.74 1.74 0 0 1 2.44.348M140.553 683.005a3.552 3.552 0 1 0-7.103 0c0 3.108 3.552 6.216 3.552 6.216s3.551-3.108 3.551-6.216"
        />
      </g>
    </g>
  </svg>
);
export default SvgFrownyFace;
